import { render, staticRenderFns } from "./Waist.vue?vue&type=template&id=13d64035&scoped=true&"
import script from "./Waist.vue?vue&type=script&lang=js&"
export * from "./Waist.vue?vue&type=script&lang=js&"
import style0 from "./Waist.vue?vue&type=style&index=0&id=13d64035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d64035",
  null
  
)

export default component.exports